import { render } from "./Header.vue?vue&type=template&id=35e15a6c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=35e15a6c&lang=css&scoped=true"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e15a6c"]])

export default __exports__